export const formatSignatureDate = (timestamp,user) => {
  const dateObj = new Date(timestamp);

  // Format date as YYYY-MM-DD
  const date = dateObj.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  // Format time as HH:MM:SS
  const time = dateObj.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  return `${user?.firstName ?user?.firstName:' '}${user?.lastName? ` ${user?.lastName}` : ' '} signed this document on ${date} at ${time}`;
};
